/**
 * CardMedia com lazy loading de imagem
 */

import React, { useState } from 'react';
import { Skeleton, Box, BoxProps } from '@mui/material';
import { Image as ImageIcon } from '@mui/icons-material';

interface LazyCardMediaProps extends Omit<BoxProps, 'component' | 'height'> {
  image: string;
  alt?: string;
  height?: string | number;
  loading?: 'lazy' | 'eager';
}

export const LazyCardMedia: React.FC<LazyCardMediaProps> = ({
  image,
  alt,
  height = 160,
  loading = 'lazy',
  sx,
  ...props
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <Box sx={{ position: 'relative', width: '100%', height }}>
      {/* Skeleton enquanto carrega */}
      {!imageLoaded && !imageError && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
      )}

      {/* Fallback se erro */}
      {imageError && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
          }}
        >
          <ImageIcon sx={{ fontSize: 64, color: 'grey.400' }} />
        </Box>
      )}

      {/* Imagem */}
      {!imageError && (
        <Box
          component="img"
          src={image}
          alt={alt}
          loading={loading}
          sx={{
            width: '100%',
            height: height,
            objectFit: 'cover',
            ...sx,
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageError(true);
            setImageLoaded(true);
          }}
          {...props}
        />
      )}
    </Box>
  );
};
